module.exports = __webpack_public_path__ + "static/media/11.78eb4683.png";